export default "__VITE_ASSET__26fe41ec__"